import { render, staticRenderFns } from "./ImgPreview.vue?vue&type=template&id=5992cdfc&scoped=true"
import script from "./ImgPreview.vue?vue&type=script&lang=js"
export * from "./ImgPreview.vue?vue&type=script&lang=js"
import style0 from "./ImgPreview.vue?vue&type=style&index=0&id=5992cdfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5992cdfc",
  null
  
)

export default component.exports